module.exports = __webpack_public_path__ + "img/rodrigo.008ad93d.webp";